// @flow
const CLEAR: '__clear__' = '__clear__'; // value of clear option used in select-field components

export default CLEAR;
